module.exports = __webpack_public_path__ + "img/paypal-plus.5773471a.png";